import { AuthSettings } from "@grabcad/company-server-shared/dist/types";

export interface IConfigureAuthProps {
    authSettings?: AuthSettings;
}

// Utility function to convert a file to a Base64 string
export const fileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(btoa(reader.result as string)); // Resolve with Base64 string
        reader.onerror = reject; // Reject on error
        reader.readAsText(file); // Read file as plain text (Base64 of text)
    });
};

export const base64ToFile = (
    base64: string,
    defaultFileName: string = "metadataCertificate"
): File | null => {
    if (!base64) {
        return null;
    }

    // Extract the MIME type and Base64 data from the string
    const [prefix, base64Data] = base64.split(",");
    const mimeType = prefix.match(/^data:(.*);base64$/)?.[1] || "application/octet-stream";

    // Decode the Base64 string to a binary string
    let binaryString: string;
    try {
        binaryString = atob(base64Data || base64); // Use base64Data if prefix exists, otherwise use the entire string
    } catch (error) {
        return null;
    }

    // Convert the binary string to a Uint8Array
    const byteArray = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
        byteArray[i] = binaryString.charCodeAt(i);
    }

    // Create a Blob from the Uint8Array
    const blob = new Blob([byteArray], { type: mimeType });

    // Create a File object from the Blob
    const fileName = `${defaultFileName}.${mimeType.split("/")[1] || "bin"}`; // Generate a file name with the correct extension
    return new File([blob], fileName, { type: mimeType });
};
